<template>
  <div>
    <a-table ref="table" size="small" class="my-table" rowKey="id" :columns="columns" :scroll="{ x: 'max-content' }"
             :dataSource="dataSource" :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange,columnWidth: 30 }"
             :pagination="false">
      <span slot="action" slot-scope="text, record" style="display: flex;justify-content: center;column-gap: 10px;" v-if="!hasChildren(record)">
        <a @click="handleView(record)" v-has="'patient:formInput'">查看详情</a>
        <!-- <a-divider type="vertical"/> -->
        <span v-has="'patient:form:unnecessary'" v-if="record.unnecessary===0">
            <a-divider type="vertical" />
            <a @click="unnecessaryPatient(record)">选填</a>
          </span>
          <span v-has="'patient:periodform:edit'">
            <a-divider type="vertical" />
            <a @click="delForm(record)" >删除</a>
          </span>
      </span>
      <span slot="formName" slot-scope="text, record" style="display: flex;justify-content: center;column-gap: 10px;">
        <a-tooltip placement="topLeft" v-if="record.unnecessary===1" style="padding-right:2px">
            <template slot="title">
              该表单可不填写
            </template>
            <a-icon type="info-circle" style="color: #FF4500" />
          </a-tooltip>
        <a v-if="!hasChildren(record)" @click="handleView(record)" >{{record.name}}</a>
        <a v-else>{{record.name}}</a>    
      </span>      
      <span slot="status" slot-scope="text, record" v-if="!hasChildren(record)">
        <a-tag :color="textInfo[text] ? textInfo[text].color : ''">{{ textInfo[text] ? textInfo[text].text : ''
          }}</a-tag>
      </span>
      <span slot="overdueSubmit" slot-scope="text, record" v-if="!hasChildren(record)">
        <a-tag v-if="text === '1'" color="red">是</a-tag>
        <!--<a-tag v-else >否</a-tag>-->
      </span>
      <span slot="pushStatus" slot-scope="text, record" v-if="!hasChildren(record)">
        <a-tag color="green" v-if="text == '1'">已推送<span v-if="record.pushUser">({{record.pushUser}})</span></a-tag>
        <a-tag color="orange" v-else>未推送</a-tag>
      </span>
      <span slot="testType" slot-scope="text, record" v-if="!hasChildren(record)">
        <a-tag color="green" v-if="text == '0'">自评</a-tag>
        <a-tag color="orange" v-else-if="text == '1'">他评</a-tag>
        <a-tag color="blue" v-else>均可</a-tag>
      </span>
    </a-table>
  </div>
</template>

<script>
import { formStatus } from '@/constants/patient'
import { postAction,getAction } from '@api/manage'
export default {
  name: 'FormTable',
  props: {
    dataSource: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data() {
    return {
      disableMixinCreated: true,
      textInfo: formStatus,
      selectedRowKeys: [],
      selectionRows: [],
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          align: 'center',
          customRender: (t, r, index) => {
              if(!r.children || r.children.length == 0){
                  return index + 1
              }else{
                  return ''
              }              
            }
        },
        {
          title: '表单名称',
          align: 'center',
          key: 'name',
          width: 300,
          dataIndex: 'name',
          scopedSlots: { customRender: 'formName' },
        },        
        {
          title: '状态',
          align: 'center',
          width: 80,
          key: 'status',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '推送状态',
          align: 'center',
          width: 90,
          dataIndex: 'pushStatus',
          scopedSlots: { customRender: 'pushStatus' },
        },
        {
          title: '录入者',
          align: 'center',
          width: 100,
          dataIndex: 'userRealname'
        },
        {
          title: '提交时间',
          align: 'center',
          width: 200,
          dataIndex: 'submitTime'
        },        
        {
          title: '最后更新时间',
          align: 'center',
          width: 150,
          dataIndex: 'updateTime'
        },
        {
          title: '填写时长',
          align: 'center',
          width: 150,
          dataIndex: 'time'
        },
        {
          title: '是否过期提交',
          align: 'center',
          width: 100,
          dataIndex: 'overdueSubmit',
          scopedSlots: { customRender: 'overdueSubmit' },
        },
   
        // {
        //   title: '选填',
        //   align: 'center',
        //   width: 60,
        //   key: 'unnecessary',
        //   dataIndex: 'unnecessary',
        //   customRender: (text, record, index) => {
        //     if (text === 1) {
        //       return '是'
        //     }
        //     else {
        //       return '否'
        //     }
        //   },
        // },
        {
          title: '测评方式',
          align: 'center',
          width: 90,
          dataIndex: 'testType',
          scopedSlots: { customRender: 'testType' },
        },
        {
          title: '操作',
          // fixed: 'right',
          align: 'center',
          // width: 350,
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        }
      ],
    }
  },
  methods: {
    handleView(record) {
      const isPad = this.$route.fullPath.startsWith('/pad')
      if (isPad) {
        this.$router.push({ path: `/pad/patient/registerform/${record.id}` })
      } else {
        this.$router.push({ path: `/project/patient/registerform/${record.id}` })
      }
    },
    onSelectChange(selectedRowKeys, selectionRows) {
      const newselectedRowKeys = []
      const newselectionRows = []
      selectionRows.forEach(item => {
        if (item.status == '1' || item.status == '2') {
          newselectedRowKeys.push(item.id);
          newselectionRows.push(item);
        }
      })
      this.selectedRowKeys = newselectedRowKeys;
      this.selectionRows = newselectionRows;
    },
    getSelectRowsInfo() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        selectionRows: this.selectionRows
      }
    },
    unnecessaryPatient(record) {
      var that = this
      this.$confirm({
        title: '提示',
        content: '您确定要将表单修改为选填吗，修改后无法撤销？',
        centered: false,
        onOk: () => {
          postAction('/patient/patientForm/unnecessaryPatient', { "patientFormId": record.id }).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$router.go(0);
              // that.$router.push({ path: `/index` });
              // const isPad=that.$route.fullPath.startsWith('/pad')
              // if(isPad){
              //   that.$router.push({path:`/pad/patient/registerview/${record.patientId}`})
              // }else{
              //   that.$router.push({path:`/project/patient/registerview/${record.patientId}`})
              // }
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
          })
        }
      })
    },
    delForm(record) {
      var that = this
      this.$confirm({
        title: '提示',
        content: '您确定要删除表单吗，删除后无法撤销？',
        centered: false,
        onOk: () => {
          getAction('/patient/patientPeriodItem/delForm', {patientFormId: record.id }).then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('unload');
            } else {
              that.$message.warning(res.message);
            }
          }).finally(() => {
          })
        }
      })
    },
    
    hasChildren(record) {
      // 判断记录是否有子节点
        return !!record.children && record.children.length > 0;
      },
  },
}
</script>

<style scoped lang="less">
.my-table {
  /deep/ .ant-table-body {
    min-width: unset!important;
    background-color: white;
  }
}

.ant-table-fixed .ant-table-cell {
  line-height: 60px;
}
.ant-table-row {
  min-height: 60px; /* 根据实际需要调整 */
  line-height: 60px; /* 使内容垂直居中 */
}
</style>
